import { render, staticRenderFns } from "./profile-my.vue?vue&type=template&id=e64da10c&"
import script from "./profile-my.vue?vue&type=script&lang=js&"
export * from "./profile-my.vue?vue&type=script&lang=js&"
import style0 from "./profile-my.vue?vue&type=style&index=0&id=e64da10c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports